import React, { useState, useEffect } from 'react';
import { WebApiCalls } from '../../webApiCalls/webApiCalls'
import _ from 'lodash'
import { KMTracking } from '../Tracking/KMTracking';
import cleanURL from '../../common/cleanURL';
import { Link } from 'react-router-dom';    

interface prop {
    categoriesArray?: any,
    props?: any
}
function Footer(props: prop) {
    const [categories, setCategories] = useState([])
    useEffect(() => {
        if (props?.categoriesArray) {
            let tempCategories: any = []
            props?.categoriesArray?.map((item) => {
                if (item?.Description !== "hidden") {
                    tempCategories = [...tempCategories, item]
                }
            })
            setCategories(tempCategories)
        } else {
            getCategories()
        }

    }, [props.categoriesArray])
    const tracker = async (eventName, _kmprops) => {
        await KMTracking(eventName, _kmprops)
    }

    const getCategories = async () => {
        await new WebApiCalls().getAllCategoriesByHerarchy().then((response) => {
            if (response) {
                let tempCategories: any = []
                response?.map((item) => {
                    if (item?.Description !== "hidden") {
                        tempCategories = [...tempCategories, item]
                    }
                })
                setCategories(tempCategories)
                // response?.map((item: any) => {
                //     if (item.ChildCategories.length > 0) {
                //         item?.ChildCategories?.map((item2) => {
                //             if (item2?.Name == name) {
                //                 setCategory(item2)
                //             }
                //             if (item?.Name == name) {
                //                 setCategory(item)
                //             }
                //         })
                //     }
                // })
            }
        })
    }
    return (
        <footer className="footer-container">

            <div className="footer">

                {/* left column */}
                <div className="footer-heading left-column">
                    <div className="logo"><img src="images/icon-frx.png" alt="" /></div>
                    <div className="text"><a target="_blank" className="social fb" href="https://www.facebook.com/FrasersPropertyRetail"
                        onClick={() => {
                            let data = { 'Current Page': 'Home' }
                            tracker('FrasersPropertyRetailFacebook', data)
                        }}
                    >@FrasersPropertyRetail</a></div>
                    <div className="text"><a target="_blank" className="social ig" href="https://www.instagram.com/fraserspropertyretail/"
                        onClick={() => {
                            let data = { 'Current Page': 'Home' }
                            tracker('fraserspropertyretailInstagram', data)
                        }}
                    >@fraserspropertyretail</a></div>
                </div>
                {/* /left column */}

                {/* right column */}
                <div className="footer-heading right-column">
                    <div className="footer-2">
                        <a className="title" target="_blank" href="https://www.frasersexperience.com/fr-page.php?CategoryID=741"
                            onClick={() => {
                                let data = { 'Current Page': 'Home' }
                                tracker('AboutFraserseStore', data)
                            }} style={{ visibility: "hidden" }} /* this is added by me: nauman */
                        >About Frasers eStore</a>
                        {categories?.map((item: any, index) => {
                            return (
                                <div className="subfooter" key={index}
                                    onClick={() => {
                                        props?.props?.history?.push(`/category/${cleanURL(item?.Name)}/${item?.ID}`)
                                        window.scrollTo(0, 0)

                                    }}>
                                    <Link to={`/category/${cleanURL(item?.Name)}/${item?.ID}`}>{_.capitalize(item.Name)}</Link>
                                </div>
                            );
                        })}
                        {/* <div className="subfooter">
                    <a   >Tech</a>
                    <a   >Wellness</a>
                    <a   >Lifestyle</a>
                    <a   >Pantry</a>
                </div> */}
                    </div>
                </div>
                {/* /right column */}

            </div>

            {/* copyright */}
            <div className="copyright">
                <div className="text">Copyright © 2023. Frasers Property Retail Management Pte. Ltd. <span>All rights reserved.</span></div>
                <div className="links">
                    <a className="text" target="_blank" href="https://www.frasersexperience.com/app-terms-of-use/"
                        onClick={() => {
                            let data = { 'Current Page': 'Home' }
                            tracker('TermsofUse', data)
                        }}
                    >Terms of Use</a>
                    <a className="text" target="_blank" href="https://www.frasersproperty.com/privacy-policy"
                        onClick={() => {
                            let data = { 'Current Page': 'Home' }
                            tracker('PrivacyPolicy', data)
                        }}
                    >Privacy Policy</a>

                </div>
            </div>
            {/* /copyright */}

        </footer>
    );
}

export default Footer;
